<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login-page">
    <header class="login-header">
      <div class="brand" @click="goLanding">
        <div class="brand-mark">H</div>
        <div class="brand-text">
          <strong>纳思 HawkSense</strong>
          <span>AI 验布平台</span>
        </div>
      </div>
      <div class="header-actions">
        <button class="contact-btn" type="button" @click="openMail">联系销售</button>
        <button class="back-home-btn" type="button" @click="goLanding">返回首页</button>
      </div>
    </header>

    <section class="login-body">
      <aside class="login-story">
        <article class="story-main-card">
          <p class="story-kicker">HAWKSENSE COMMAND ACCESS</p>
          <h1>欢迎进入 HawkSense 控制台</h1>
          <p class="story-subtitle">
            登录后可统一查看设备在线状态、验布任务数据与识别结果，完成从检测到复盘的全流程闭环。
          </p>
          <div class="story-chip-row">
            <span class="story-chip">Edge AI</span>
            <span class="story-chip">Real-time Monitor</span>
            <span class="story-chip">Traceable Data</span>
          </div>
        </article>

        <div class="story-metric-grid">
          <article v-for="item in introCards" :key="item.title" class="story-metric-card">
            <p class="metric-value">{{ item.value }}</p>
            <h3>{{ item.title }}</h3>
            <p class="metric-desc">{{ item.desc }}</p>
          </article>
        </div>
      </aside>

      <div class="login-panel">
        <Card :bordered="false">
          <div class="card-head">
            <p class="card-kicker">Secure Sign In</p>
            <h2>账号登录</h2>
            <p>请输入账号和密码访问管理后台。</p>
          </div>
          <div class="form-con">
            <login-form @on-success-valid="handleSubmit"></login-form>
            <div class="helper-row">
              <p class="login-tip">忘记密码请联系管理员</p>
              <p class="login-tip">首次登录建议修改默认密码</p>
            </div>
          </div>
        </Card>
      </div>
    </section>

    <div class="login-bg-glow login-bg-glow-1"></div>
    <div class="login-bg-glow login-bg-glow-2"></div>
    <div class="login-bg-line"></div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
import routes from '@/router/routers'
import { getDefaultRouteNameByAccess } from '@/libs/util'

export default {
  components: {
    LoginForm
  },
  data () {
    return {
      introCards: [
        {
          value: '90%+',
          title: '缺陷检出率',
          desc: 'AI 模型高精度识别，减少漏检误检。'
        },
        {
          value: '50-120m/min',
          title: '验布速度',
          desc: '显著高于传统人工，效率稳定可控。'
        },
        {
          value: 'OTA',
          title: '在线升级',
          desc: '算法持续迭代，设备能力不断增强。'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit ({ username, password }) {
      this.handleLogin({ username, password }).then(res => {
        this.getUserInfo().then(res => {
          const userAccess = this.$store.state.user.access
          const defaultHome = getDefaultRouteNameByAccess(userAccess, routes)
          this.$router.push({
            name: defaultHome
          })
        })
      })
    },
    goLanding () {
      this.$router.push({ name: 'landing' })
    },
    openMail () {
      window.location.href = 'mailto:fish@sinano-ai.com'
    }
  }
}
</script>
